<template>
  <!-- "+ إضافة خيار" pill; pressed, it turns into a field to type the new option in. -->
  <button v-if="!editing" type="button" class="choice choice--add" @click="open">
    <v-icon small>mdi-plus</v-icon>
    إضافة خيار
  </button>
  <form v-else class="add-option" @submit.prevent="submit">
    <v-text-field
      ref="field"
      v-model="title"
      dense
      outlined
      hide-details
      autofocus
      placeholder="اكتب الخيار الجديد"
      :disabled="saving"
      @keydown.esc="close"
    ></v-text-field>
    <v-btn type="submit" icon small color="primary" :loading="saving" :disabled="title.trim() == ''" aria-label="حفظ الخيار">
      <v-icon>mdi-check</v-icon>
    </v-btn>
    <v-btn type="button" icon small :disabled="saving" aria-label="إلغاء" @click="close">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </form>
</template>

<script>
export default {
  name: "AddOption",
  props: {
    // Called with the trimmed title; resolves once the option is added (the field then closes), rejects to keep it open.
    save: { type: Function, required: true },
  },
  data() {
    return {
      editing: false,
      saving: false,
      title: "",
    };
  },
  methods: {
    open() {
      this.title = "";
      this.editing = true;
    },
    close() {
      this.editing = false;
    },
    async submit() {
      const title = this.title.trim();
      if (title == "" || this.saving) return;
      this.saving = true;
      try {
        await this.save(title);
        this.close();
      } catch (error) {
        // Already reported (http interceptor or the caller); the typed text stays so it can be retried.
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
